import React from 'react';

interface SvgClipboardProps {
  color?: string;
  width?: number;
  height?: number;
}

const SvgClipboard: React.FC<SvgClipboardProps> = ({
  color = '#292D32',
  width = 24,
  height = 24
}) => (
  <svg width={width} height={height} viewBox="0 0 634 634" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M197.82 356.078H356.077V395.642H197.82V356.078Z" fill={color}/>
    <path d="M197.82 257.168H435.205V296.732H197.82V257.168Z" fill={color}/>
    <path d="M197.82 454.988H296.731V494.552H197.82V454.988Z" fill={color}/>
    <path d="M494.552 98.9107H435.206V79.1286C435.206 68.6355 431.037 58.5722 423.617 51.1525C416.198 43.7328 406.134 39.5645 395.641 39.5645H237.385C226.892 39.5645 216.828 43.7328 209.409 51.1525C201.989 58.5722 197.821 68.6355 197.821 79.1286V98.9107H138.474C127.981 98.9107 117.918 103.079 110.498 110.499C103.079 117.918 98.9102 127.982 98.9102 138.475V553.899C98.9102 564.392 103.079 574.455 110.498 581.875C117.918 589.294 127.981 593.463 138.474 593.463H494.552C505.045 593.463 515.108 589.294 522.528 581.875C529.948 574.455 534.116 564.392 534.116 553.899V138.475C534.116 127.982 529.948 117.918 522.528 110.499C515.108 103.079 505.045 98.9107 494.552 98.9107ZM237.385 79.1286H395.641V158.257H237.385V79.1286ZM494.552 553.899H138.474V138.475H197.821V197.821H435.206V138.475H494.552V553.899Z" fill={color}/>
  </svg>
);

export default SvgClipboard;
export { SvgClipboard }; 